'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageSection = function (_React$Component) {
  (0, _inherits3.default)(PageSection, _React$Component);

  function PageSection() {
    (0, _classCallCheck3.default)(this, PageSection);
    return (0, _possibleConstructorReturn3.default)(this, (PageSection.__proto__ || (0, _getPrototypeOf2.default)(PageSection)).apply(this, arguments));
  }

  (0, _createClass3.default)(PageSection, [{
    key: 'render',
    value: function render() {
      var styles = require('./PageSection.scss');

      return _react2.default.createElement(
        'section',
        { className: styles.PageSection },
        _react2.default.createElement(
          'div',
          { className: this.props.className },
          this.props.children
        )
      );
    }
  }]);
  return PageSection;
}(_react2.default.Component);

exports.default = PageSection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PageSection/PageSection.jsx
// module id = 2646
// module chunks = 0